var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"id":"loop","src":require("@/assets/img/Graphics-1.svg"),"alt":"illustration"}})}
var staticRenderFns = []

export { render, staticRenderFns }